import * as z from "zod";

export const startShopperAgentAiRetriggers = {
  name: "startShopperAgentAiRetriggers" as const,
  input: z.object({
    /** shopper_agent_conversation topic ids (cnv_... or raw bigint). */
    conversationTopicIds: z.array(z.string()).min(1),
  }),
  output: z.object({
    started: z.array(
      z.object({ conversationTopicId: z.string(), workflowId: z.string() }),
    ),
    skipped: z.array(
      z.object({ conversationTopicId: z.string(), reason: z.string() }),
    ),
  }),
};
